import Vue from "vue";
import PickedProduct from "../models/PickedProductClass";
import { Constants } from "../functions/constants";

export const store = Vue.observable({
    products: new Array(Constants.PRODUCTS_COMPARE.NUMBER_OF_SLOTS),
    usedSlots: 0
});

export const mutations = {
    pickProduct(id, title, imageUrl, productUrl) {
        if (store.usedSlots >= Constants.PRODUCTS_COMPARE.NUMBER_OF_SLOTS)
            return;

        let productToPick = new PickedProduct(id, title, imageUrl, productUrl);
        if (productToPick.isValid() === false)
            return;

        let indexOfProduct = store.products.findIndex(p => (p && p.id === productToPick.id));
        if (indexOfProduct > -1)
            return

        let isProductAdded = false;
        let iterator = 0;
        while (isProductAdded === false && iterator < Constants.PRODUCTS_COMPARE.NUMBER_OF_SLOTS) {
            let product = store.products[iterator];
            if (!product || Object.keys(product).length === 0) {
                Vue.set(store.products, iterator, productToPick);
                store.usedSlots++;
                isProductAdded = true;
            }

            iterator++;
        }
    },
    unpickProduct(id) {
        if (!id || store.usedSlots < 1)
            return;

        let indexOfProduct = store.products.findIndex(p => (p && p.id === id));
        if (indexOfProduct > -1) {
            store.products[indexOfProduct] = {};
            store.usedSlots--;
            GlobalApp.EventHub.raiseEvent(Constants.EVENTS.COMPARE_PRODUCTS_REMOVED);
        }
    },
    resetPickedProducts() {
        store.products = new Array(Constants.PRODUCTS_COMPARE.NUMBER_OF_SLOTS);
        store.usedSlots = 0;
        GlobalApp.EventHub.raiseEvent(Constants.EVENTS.COMPARE_PRODUCTS_REMOVED);
    }
};